import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Box,
    Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../../components/SearchBar";

const FikraLabBusinessReport = () => {
    const navigate = useNavigate();
    const entrepreneurs = [
        {
            id: 1,
            userName: "Aisha Khan",
            userEmail: "aisha.khan@example.com",
            category: "Fashion & Apparel",
            skills: "Digital & Design",
            startupBudget: "$5,000 - $10,000",
            time: "Part-time (20–30 hours/week)",
            experience: "First-time Entrepreneur",
            location: "Dubai, UAE",
            idea: "A sustainable clothing line made from recycled materials.",
        },
        {
            id: 2,
            userName: "Rohan Mehta",
            userEmail: "rohan.mehta@example.com",
            category: "Beauty & Wellness",
            skills: "Marketing & Sales",
            startupBudget: "$10,000 - $25,000",
            time: "Full-time (40+ hours/week)",
            experience: "Some Experience",
            location: "Mumbai, India",
            idea: "An AI-driven skincare recommendation platform.",
        },
    ];
    return (
        <>
            <div className="main_title">
                <h1>Fikra Lab – Business Report</h1>
            </div>
            <div className="table_flex">
                <div className="lt">
                    <div className="cards">
                        <div className="table_header">
                            <div className="left_s">
                                <SearchBar
                                    searchTerm={""}
                                    setDebouncedSearchTerm={() => { }}
                                    placeholder="Search..."
                                />
                            </div>
                        </div>
                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Sr. No</TableCell>
                                        <TableCell>User Details</TableCell>
                                        <TableCell>Category</TableCell>
                                        <TableCell>Skills</TableCell>
                                        <TableCell>Startup Budget</TableCell>
                                        <TableCell>Time Commitment</TableCell>
                                        <TableCell>Business Experience</TableCell>
                                        <TableCell>Location</TableCell>
                                        <TableCell>Business Idea</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {entrepreneurs.map((item, index) => (
                                        <TableRow hover key={item.id}>
                                            <TableCell>{index + 1}</TableCell>

                                            {/* User Details */}
                                            <TableCell>
                                                <div>
                                                    <strong>{item.userName}</strong>
                                                    <p style={{ margin: 0, fontSize: "0.85rem", color: "#666" }}>
                                                        {item.userEmail}
                                                    </p>
                                                </div>
                                            </TableCell>

                                            <TableCell>{item.category}</TableCell>
                                            <TableCell>{item.skills}</TableCell>
                                            <TableCell>{item.startupBudget}</TableCell>
                                            <TableCell>{item.time}</TableCell>
                                            <TableCell>{item.experience}</TableCell>
                                            <TableCell>{item.location}</TableCell>
                                            <TableCell>{item.idea}</TableCell>

                                            <TableCell>
                                                <div className="table_actions v2">
                                                    <IconButton onClick={() => navigate("/fikra-lab-business-report/view")}>
                                                        <img
                                                            src="/static/images/eye_icon.svg"
                                                            alt="View"
                                                        />
                                                    </IconButton>
                                                    <IconButton>
                                                        <img
                                                            src="/static/images/trash2_icon.svg"
                                                            alt="Delete"
                                                        />
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
                <div className="rt">
                    <div className="ai_panel">
                        <h4>AI Insights</h4>
                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>7 SKUs</b> need immediate attention
                            </p>
                        </div>
                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>
                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>
                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_002</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_010</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FikraLabBusinessReport;
